import { __ } from '@wordpress/i18n';

const Header = ( {time = ''}: {time: string} ) => {
    if ( ! time ) {
        return '';
    }

    return(
        <div className="header">
            <h3>{__( 'Delivery details', 'dokan' )}</h3>
            <div className="delivery-timezone dokan-delivery-time-tooltip" data-tip={__( 'Date & time is based on current site time.', 'dokan' )}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="18" viewBox="0 0 24 24" stroke="#333333">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.85" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <span>{time}</span>
            </div>
        </div>
    );
}

export default Header;
